import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-server-error-control',
  templateUrl: './server-error-control.component.html',
  styleUrls: ['./server-error-control.component.css']
})
export class ServerErrorControlComponent implements OnInit {

  // tslint:disable-next-line: no-input-rename
  @Input() errorHeader;
  // tslint:disable-next-line: no-input-rename
  @Input() errorList = [];

  constructor() { }
  ngOnInit() {

  }
}
